var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _taggedTemplateLiteral = require("/workspace/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _templateObject, _templateObject2, _templateObject3;

var ws = require('isomorphic-ws');

var _require = require('subscriptions-transport-ws'),
    SubscriptionClient = _require.SubscriptionClient;

var _require2 = require('graphql-request'),
    request = _require2.request,
    gql = _require2.gql;

var _require3 = require('./../constants'),
    graphAPIEndpoints = _require3.graphAPIEndpoints,
    graphWSEndpoints = _require3.graphWSEndpoints,
    barAddress = _require3.barAddress;

var _require4 = require('./../utils'),
    timestampToBlock = _require4.timestampToBlock;

module.exports = {
  info: function info() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, _ref$block, block, _ref$timestamp, timestamp, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$block = _ref.block, block = _ref$block === void 0 ? undefined : _ref$block, _ref$timestamp = _ref.timestamp, timestamp = _ref$timestamp === void 0 ? undefined : _ref$timestamp;

              if (!block) {
                _context.next = 5;
                break;
              }

              _context.t0 = block;
              _context.next = 13;
              break;

            case 5:
              if (!timestamp) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return timestampToBlock(timestamp);

            case 8:
              _context.t1 = _context.sent;
              _context.next = 12;
              break;

            case 11:
              _context.t1 = undefined;

            case 12:
              _context.t0 = _context.t1;

            case 13:
              block = _context.t0;
              block = block ? "block: { number: ".concat(block, " }") : "";
              _context.next = 17;
              return request(graphAPIEndpoints.bar, gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["{\n                    bar(id: \"", "\", ", ") {\n                        ", "\n                    }\n                }"])), barAddress, block, _info.properties.toString()));

            case 17:
              result = _context.sent;
              return _context.abrupt("return", _info.callback(result.bar));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  observeInfo: function observeInfo() {
    var query = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            subscription {\n                bar(id: \"", "\") {\n                    ", "\n                }\n        }"])), barAddress, _info.properties.toString());
    var client = new SubscriptionClient(graphWSEndpoints.bar, {
      reconnect: true
    }, ws);
    var observable = client.request({
      query: query
    });
    return {
      subscribe: function subscribe(_ref2) {
        var _next = _ref2.next,
            error = _ref2.error,
            complete = _ref2.complete;
        return observable.subscribe({
          next: function next(results) {
            _next(_info.callback(results.data.bar));
          },
          error: error,
          complete: complete
        });
      }
    };
  },
  user: function user() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref3, _ref3$block, block, _ref3$timestamp, timestamp, _ref3$user_address, user_address, result;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref3 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref3$block = _ref3.block, block = _ref3$block === void 0 ? undefined : _ref3$block, _ref3$timestamp = _ref3.timestamp, timestamp = _ref3$timestamp === void 0 ? undefined : _ref3$timestamp, _ref3$user_address = _ref3.user_address, user_address = _ref3$user_address === void 0 ? undefined : _ref3$user_address;

              if (user_address) {
                _context2.next = 3;
                break;
              }

              throw new Error("sushi-data: User address undefined");

            case 3:
              if (!block) {
                _context2.next = 7;
                break;
              }

              _context2.t0 = block;
              _context2.next = 15;
              break;

            case 7:
              if (!timestamp) {
                _context2.next = 13;
                break;
              }

              _context2.next = 10;
              return timestampToBlock(timestamp);

            case 10:
              _context2.t1 = _context2.sent;
              _context2.next = 14;
              break;

            case 13:
              _context2.t1 = undefined;

            case 14:
              _context2.t0 = _context2.t1;

            case 15:
              block = _context2.t0;
              block = block ? "block: { number: ".concat(block, " }") : "";
              _context2.next = 19;
              return request(graphAPIEndpoints.bar, gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["{\n                    user(id: \"", "\", ", ") {\n                        ", "\n                    }\n                }"])), user_address.toLowerCase(), block, _user.properties.toString()));

            case 19:
              result = _context2.sent;
              return _context2.abrupt("return", _user.callback(result.user));

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};
var _info = {
  properties: ['decimals', 'name', 'sushi', 'symbol', 'totalSupply', 'ratio', 'xSushiMinted', 'xSushiBurned', 'sushiStaked', 'sushiStakedUSD', 'sushiHarvested', 'sushiHarvestedUSD', 'xSushiAge', 'xSushiAgeDestroyed', 'updatedAt'],
  callback: function callback(results) {
    return {
      decimals: Number(results.decimals),
      name: results.name,
      sushi: results.sushi,
      symbol: results.symbol,
      totalSupply: Number(results.totalSupply),
      ratio: Number(results.ratio),
      xSushiMinted: Number(results.xSushiMinted),
      xSushiBurned: Number(results.xSushiBurned),
      sushiStaked: Number(results.totalSupply) * Number(results.ratio),
      sushiStakedUSD: Number(results.sushiStakedUSD),
      sushiHarvested: Number(results.sushiHarvested),
      sushiHarvestedUSD: Number(results.sushiHarvestedUSD),
      xSushiAge: Number(results.xSushiAge),
      xSushiAgeDestroyed: Number(results.xSushiAgeDestroyed),
      updatedAt: Number(results.updatedAt)
    };
  }
};
var _user = {
  properties: ['xSushi', 'xSushiIn', 'xSushiOut', 'xSushiMinted', 'xSushiBurned', 'xSushiOffset', 'xSushiAge', 'xSushiAgeDestroyed', 'sushiStaked', 'sushiStakedUSD', 'sushiHarvested', 'sushiHarvestedUSD', 'sushiIn', 'sushiOut', 'usdOut', 'usdIn', 'updatedAt', 'sushiOffset', 'usdOffset'],
  callback: function callback(results) {
    return {
      xSushi: Number(results.xSushi),
      xSushiIn: Number(results.xSushiIn),
      xSushiOut: Number(results.xSushiOut),
      xSushiMinted: Number(results.xSushiMinted),
      xSushiBurned: Number(results.xSushiBurned),
      xSushiOffset: Number(results.xSushiOffset),
      xSushiAge: Number(results.xSushiAge),
      xSushiAgeDestroyed: Number(results.xSushiAgeDestroyed),
      sushiStaked: Number(results.sushiStaked),
      sushiStakedUSD: Number(results.sushiStakedUSD),
      sushiHarvested: Number(results.sushiHarvested),
      sushiHarvestedUSD: Number(results.sushiHarvestedUSD),
      sushiIn: Number(results.sushiIn),
      sushiOut: Number(results.sushiOut),
      usdOut: Number(results.usdOut),
      usdIn: Number(results.usdIn),
      updatedAt: Number(results.updatedAt),
      sushiOffset: Number(results.sushiOffset),
      usdOffset: Number(results.usdOffset)
    };
  }
};